import { createAction, props } from '@ngrx/store'
import {
    ContractOwnerParamDto,
    ContractOwnerParamRequestDto,
    ContractParcelDataDo, ContractRelatedDto, Drupoz,
    ParcelDto,
    Subject,
    SubjectContactResponseDto, ValorizationType, VersionType, Zpvypo,
} from '../../../../../api/backend'
import { RepresentativeOriginEnum } from '../../../../../domain/subject/enums/representative-origin.enum'
import { ContractCreateFeModel } from '../../../contract/edit/state/edit.reducer'
import { ContractTaskEnum } from '../../../../../shared/enums/contract-task.enum'
import { ParcelFeDto } from '../../../../parcels/shared/parcel-fe-dto.model'

export const SOURCE = '[Subcontract Edit]'

export const addParcels = createAction(
    `${SOURCE} AddParcels`, props<{ parcels: ParcelDto[] }>()
)

export const setContractCpds = createAction(
    `${SOURCE} SetContractCpds`, props<{ cpds: any[] }>()
)

export const prepareSetParcels = createAction(
    `${SOURCE} PrepareSetParcels`, props<{ parcels: ParcelDto[] }>()
)

export const setParcelsAndOrder = createAction(
    `${SOURCE} setParcelsAndOrder`, props<{ parcels: ParcelDto[] }>()
)

export const setTotalAcreage = createAction(
    `${SOURCE} SetTotalAcreage`, props<{ totalAcreage: number }>()
)

export const addContractTenant = createAction(
    `${SOURCE} AddContractOwner`, props<{ subject: SubjectContactResponseDto | Subject }>()
)

export const setSubcontractEditTenants = createAction(
    `${SOURCE} setSubcontractEditTenants`, props<{ tenants: any[] }>()
)

export const setSubcontractEditTenantsIds = createAction(
    `${SOURCE} setSubcontractEditTenantsIds`, props<{ tenantIds: number[] }>()
)

export const setContractOwnerIds = createAction(
    `${SOURCE} SetContractOwnerIds`, props<{ ownerIds: number[] }>()
)

export const addContractOwnerParam = createAction(
    `${SOURCE} AddContractOwnerParam`, props<{ ownerparams: ContractOwnerParamRequestDto[] }>()
)

export const setContractDefaultSignatories = createAction(
    `${SOURCE} SetContractDefaultSignatories`, props<{ origin: RepresentativeOriginEnum; items: any[] }>()
)

export const setSameLvAndKatuze = createAction(
    `${SOURCE} SetSameLvAndKatuze`, props<{ sameLVAndKatuze: boolean }>()
)

export const setParcels = createAction(
    `${SOURCE} SetParcels`, props<{ parcels: ParcelDto[] }>()
)

export const setParcelsAndIds = createAction(
    `${SOURCE} SetParcelsAndIds`, props<{ parcels: ParcelDto[]; parcelIds: number[] }>()
)

export const setContractParcelIds = createAction(
    `${SOURCE} SetContractParcelIds`, props<{ parcelIds: number[] }>()
)

export const computeContractPriceAndTax = createAction( // Effect
    `${SOURCE} ComputeContractPriceAndTax`
)

export const setContractPriceDeal = createAction(
    `${SOURCE} SetContractPriceDeal`, props<{ priceDeal: number }>()
)
export const setContractPriceDealValorization = createAction(
    `${SOURCE} setContractPriceDealValorization`, props<{ priceDealValorization: number }>()
)
export const setContractPercentageValorization = createAction(
    `${SOURCE} SetContractPercentageValorization`, props<{ percentageValorization: number }>()
)
export const setContractTaxOwnerTo = createAction(
    `${SOURCE} SetContractTaxOwnerTo`, props<{ ownerId: number }>()
)

export const setEditedCpdParcelRent = createAction(
    `${SOURCE} SetEditedCpdParcelRent`, props<{ parcelRentAveragePrice: string; parcelRentFromAcreage: string; parcelRentParcelPrice: string; useParcelRent: boolean }>()
)

export const setContractContractRentDrupozAndUnknownCollection = createAction(
    `${SOURCE} SetContractContractRentDrupozAndUnknownCollection`, props<{ contractRentDrupozCollection: any[]; contractRentUnknownCollection: any[] }>()
)

export const setContractTaxTenant = createAction(
    `${SOURCE} setContractTaxTenant`, props<{ taxTenant: number }>()
)

export const setEditedCpdWithConsequencies = createAction(
    `${SOURCE} SetEditedCpdWithConsequencies`, props<{ updatedEditedCpd: any; updatedCpds: ContractParcelDataDo[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number}>()
)

export const setEditedCpd = createAction(
    `${SOURCE} SetEditedCpd`, props<{ editedCPD: any }>()
)

export const setEditedParcel = createAction(
    `${SOURCE} setEditedParcel`, props<{ editedParcel: ParcelFeDto }>()
)

export const orderParcels = createAction( // Effect
    `${SOURCE} OrderParcels`, props<{ orderBy: string; parcelsOrder: { sortedBy: string; desc: boolean } }>()
)

export const reorderParcels = createAction( // Effect
    `${SOURCE} ReorderParcels`, props<{ parcelsOrder: { sortedBy: string; desc: boolean } }>()
)

export const removeParcel = createAction( // Effect
    `${SOURCE} RemoveParcel`, props<{ parcelId: number }>()
)

export const removeAllParcels = createAction( // Effect
    `${SOURCE} RemoveAllParcels`,
)

export const prepareSetEditedCpdDnepduos = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduos`, props<{ number: number; dnepduos: any }>()
)

export const resetSubcontractEdit = createAction(
    `${SOURCE} resetSubcontractEdit`,
)

export const resetState = createAction(
    `${SOURCE} ResetState`, props<{ contractNumberFormat: string; createIndividualDocuments: boolean; paymentsFromEconomicYear: boolean }>()
)

export const resetEditedCpdDnepduos = createAction(
    `${SOURCE} ResetEditedCpdDnepduos`, props<{ updatedEditedCpd: any; updatedCpds: ContractParcelDataDo[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number  }>()
)

export const prepareResetEditedCpdDnepduos = createAction( // Effect
    `${SOURCE} PrepareResetEditedCpdDnepduos`, props<{ number: number }>()
)

export const setContractAutoProlongationMonths = createAction(
    `${SOURCE} SetContractAutoProlongationMonths`, props<{ autoProlongationMonths: number; repeatedly: boolean }>()
)

export const setContractAutoProlongationMonthsUnit = createAction(
    `${SOURCE} SetContractAutoProlongationMonthsUnit`, props<{ value: string }>()
)

export const beforeSetContract = createAction(
    `${SOURCE} BeforeSetContract`, props<{ contract: ContractCreateFeModel; recomputePriceAndTax?: boolean }>()
)

export const setContractParamTemplates = createAction(
    `${SOURCE} SetContractParamTemplates`, props<{ contractParamTemplates: any }>()
)

export const setSelectedContractTemplate = createAction(
    `${SOURCE} setSelectedContractTemplate`, props<{ selectedContractTemplate: any }>()
)

export const setContractExpirationDate = createAction(
    `${SOURCE} SetContractExpirationDate`, props<{ expirationDate: string }>()
)

export const setContract = createAction(
    `${SOURCE} SetContract`, props<{ contract: ContractCreateFeModel; ownerIds?: number[]; parcelIds?: number[]; tenantIds?: number[] }>()
)

export const setIsAppendix = createAction(
    `${SOURCE} SetIsAppendix`, props<{ isAppendix: boolean }>()
)

export const setIsSuccessive = createAction(
    `${SOURCE} SetIsSuccessive`, props<{ isSuccessive: boolean }>()
)

export const setIsFormActive = createAction(
    `${SOURCE} SetIsFormActive`, props<{ isFormActive: boolean }>()
)

export const prepareSetComputedContractNumber = createAction(
    `${SOURCE} PrepareSetComputedContractNumber`, props<{ signatureYear: number }>()
)
export const setComputedContractNumber = createAction(
    `${SOURCE} SetComputedContractNumber`, props<{ number: number }>()
)

export const setContractCounterpartyNumber = createAction(
    `${SOURCE} SetContractCounterpartyNumber`, props<{ counterpartyNumber: string }>()
)

export const setContractCreateIndividualDocuments = createAction(
    `${SOURCE} SetContractCreateIndividualDocuments`, props<{ value: boolean }>()
)
export const setContractDocumentNote = createAction(
    `${SOURCE} SetContractDocumentNote`, props<{ note: string }>()
)
export const setContractDocumentTemplate = createAction(
    `${SOURCE} SetContractDocumentTemplate`, props<{ template: number }>()
)

export const setContractDurationMonths = createAction(
    `${SOURCE} SetContractDurationMonths`, props<{ durationMonths: number }>()
)
export const setContractDurationMonthsUnit = createAction(
    `${SOURCE} SetContractDurationMonthsUnit`, props<{ durationMonthsUnit: string }>()
)
export const setContractDurationToDate = createAction(
    `${SOURCE} SetContractDurationToDate`, props<{ durationToDate: string }>()
)

export const setContractDurationPeriod = createAction(
    `${SOURCE} SetContractDurationPeriod`, props<{ value: string }>()
)

export const setContractFirstNoticeAfterMonths = createAction(
    `${SOURCE} SetContractFirstNoticeAfterMonths`, props<{ firstNoticeAfterMonths: number }>()
)
export const setContractFirstNoticeAfterMonthsUnit = createAction(
    `${SOURCE} SetContractFirstNoticeAfterMonthsUnit`, props<{ firstNoticeAfterMonthsUnit: string }>()
)
export const setContractFurtherRentPossible = createAction(
    `${SOURCE} setContractFurtherRentPossible`, props<{ furtherRentPossible: boolean }>()
)

export const setFirstPossibleTerminationDate = createAction(
    `${SOURCE} setFirstPossibleTerminationDate`, props<{ firstPossibleTerminationDate: string }>()
)

export const setContractInflationLimit = createAction(
    `${SOURCE} SetContractInflationLimit`, props<{ inflationLimit: number }>()
)
export const setContractLastNoticeBeforeMonths = createAction(
    `${SOURCE} SetContractLastNoticeBeforeMonths`, props<{ lastNoticeBeforeMonths: number }>()
)
export const setContractLastNoticeBeforeMonthsUnit = createAction(
    `${SOURCE} SetContractLastNoticeBeforeMonthsUnit`, props<{ lastNoticeBeforeMonthsUnit: string }>()
)
export const setContractNote = createAction(
    `${SOURCE} setContractNote`, props<{ note: string }>()
)

export const setContractNoticePeriodMonths = createAction(
    `${SOURCE} SetContractNoticePeriodMonths`, props<{ noticePeriodMonths: number }>()
)
export const setContractNoticePeriodMonthsUnit = createAction(
    `${SOURCE} setContractNoticePeriodMonthsUnit`, props<{ noticePeriodMonthsUnit: string }>()
)
export const setContractNumberCustom = createAction(
    `${SOURCE} SetContractNumberCustom`, props<{ contractNumberCustom: string }>()
)

export const setContractOwnerParam = createAction(
    `${SOURCE} SetContractOwnerParam`, props<{ ownerparams: ContractOwnerParamRequestDto[] | ContractOwnerParamDto[] }>()
)
export const prepareSetContractParamTemplates = createAction(
    `${SOURCE} PrepareSetContractParamTemplates`, props<{ contractParamTemplates: any }>()
)

export const setContractParcelRent = createAction(
    `${SOURCE} SetContractParcelRent`, props<{ parcelRentHybrid: string }>()
)

export const prepareSetEditedCpdProperty = createAction(
    `${SOURCE} PrepareSetEditedCpdProperty`, props<{ property: string; value: any }>()
)

export const prepareSetEditedCpdProperties = createAction(
    `${SOURCE} PrepareSetEditedCpdProperties`, props<{ properties: Array<{ key: string; value: any }> }>()
)

export const setContractPaymentsFromEconomicYear = createAction(
    `${SOURCE} SetContractPaymentsFromEconomicYear`, props<{ paymentsFromEconomicYear: boolean }>()
)
export const setContractPayTaxOwner = createAction(
    `${SOURCE} setContractPayTaxOwner`, props<{ payTaxOwner: boolean }>()
)

export const setContractPayoutToId = createAction(
    `${SOURCE} SetContractPayoutToId`, props<{ payoutToId: number }>()
)
export const setContractRentType = createAction(
    `${SOURCE} SetContractRentType`, props<{ rentType: string }>()
)

export const setContractSelectedTemplate = createAction(
    `${SOURCE} SetContractSelectedTemplate`, props<{ selectedContractTemplate: any }>()
)

export const setIsRentTypeDefined = createAction(
    `${SOURCE} SetIsRentTypeDefined`, props<{ isRentTypeDefined: boolean }>()
)

export const setRentDrupozCollection = createAction(
    `${SOURCE} SetRentDrupozCollection`, props<{ rentDrupozCollection: any[] }>()
)
export const setRentUnknownCollection = createAction(
    `${SOURCE} setRentUnknownCollection`, props<{ rentUnknownCollection: any[] }>()
)

export const setContractSignatureDate = createAction(
    `${SOURCE} SetContractSignatureDate`, props<{ signatureDate: string }>()
)

export const setSignatureYear = createAction(
    `${SOURCE} SetSignatureYear`, props<{ signatureYear: number }>()
)

export const setContractSignatureDocuments = createAction(
    `${SOURCE} SetContractSignatureDocuments`, props<{ signatureDocuments: any[] }>()
)

export const setContractSignatureDocumentsGroup = createAction(
    `${SOURCE} SetContractSignatureDocumentsGroup`, props<{ signatureDocuments: any[] }>()
)

export const setContractTaxConcerned = createAction(
    `${SOURCE} SetContractTaxConcerned`, props<{ taxConcerned: boolean }>()
)

export const setContractTaxOwnerToId = createAction(
    `${SOURCE} SetContractTaxOwnerToId`, props<{ taxOwnerToId: number }>()
)

export const setContractTenantHasPreemption = createAction(
    `${SOURCE} setContractTenantHasPreemption`, props<{ tenantHasPreemption: boolean }>()
)

export const setContractToEconomicYear = createAction(
    `${SOURCE} SetContractToEconomicYear`, props<{ toEconomicYear: boolean }>()
)

export const setContractUseRentDrupoz = createAction(
    `${SOURCE} SetContractUseRentDrupoz`, props<{ useRentDrupoz: boolean }>()
)

export const setContractValorizationType = createAction(
    `${SOURCE} SetContractValorizationType`, props<{ valorizationType: ValorizationType }>()
)
export const setContractValorizeOrInflateToDate = createAction(
    `${SOURCE} SetContractValorizeOrInflateToDate`, props<{ valorizeOrInflateToDate: string }>()
)

export const setContractVersionType = createAction(
    `${SOURCE} SetContractVersionType`, props<{ versionType:  VersionType }>()
)

export const setContractYearAndNumber = createAction(
    `${SOURCE} SetContractYearAndNumber`, props<{ year: number; number: number }>()
)
export const prepareSetEditedCpdDnepduosAcreage = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosAcreage`, props<{ number: number; acreage: number }>()
)
export const prepareSetEditedCpdDnepduosYear = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosYear`, props<{ number: number; year: number }>()
)

export const onEditedCpdOnDrupozChange = createAction(
    `${SOURCE} OnEditedCpdOnDrupozChange`, props<{ drupozKodMan: any; useTaxReturnDrupozKodOriginal: any }>()
)

export const onEditedCpdZpvypoChange = createAction(
    `${SOURCE} OnEditedCpdZpvypoChange`, props<{ katuzeKod: number; parcelId: number; drupozKodMan: number; drupozKod: number; zpvypoKodMan: number }>()
)

export const setEditedCpdTaxPayerIdAndTaxTenant = createAction(
    `${SOURCE} SetEditedCpdTaxPayerIdAndTaxTenant`, props<{ cpdTaxPayerId: any; cpdTaxTenant: any }>()
)

export const setEditedParcelPronajataVymeraVolba = createAction(
    `${SOURCE} setEditedParcelPronajataVymeraVolba`, props<{ pronajataVymeraVolba: string }>()
)
export const setEditedParcelPronajataVymeraVolbaAndZdroj = createAction(
    `${SOURCE} SetEditedParcelPronajataVymeraVolbaAndZdroj`, props<{ pronajataVymeraVolba: string; pronajataVymeraZdroj: string }>()
)
export const setEditedParcelKoeficientMan = createAction(
    `${SOURCE} SetEditedParcelKoeficientMan`, props<{ koeficientMan: number }>()
)
export const setAttachments = createAction(
    `${SOURCE} SetAttachments`, props<{ attachments: any[] }>()
)
export const setAttachmentsLoading = createAction(
    `${SOURCE} SetAttachmentsLoading`, props<{ loading: boolean }>()
)
export const setDrupozs = createAction(
    `${SOURCE} SetDrupozs`, props<{ drupozs: Drupoz[] }>()
)
export const setEditedOwnerships = createAction(
    `${SOURCE} setEditedOwnerships`, props<{ editedOwnerships: any[] }>()
)
export const setEpodnepduoses = createAction(
    `${SOURCE} setEpodnepduoses`, props<{ epodnepduoses: any[] }>()
)
export const setIsEdit = createAction(
    `${SOURCE} SetIsEdit`, props<{ isEdit: boolean }>()
)
export const setIsEditingContract = createAction(
    `${SOURCE} SetIsEditingContract`, props<{ isEditingContract: boolean }>()
)
export const setEditSessionKey = createAction(
    `${SOURCE} SetEditSessionKey`, props<{ editSessionKey: string }>()
)
export const setIsLoading = createAction(
    `${SOURCE} SetIsLoading`, props<{ isLoading: boolean }>()
)
export const setMassAcreage = createAction(
    `${SOURCE} SetMassAcreage`, props<{ acreageMap: any }>()
)

export const updateOwners = createAction(
    `${SOURCE} UpdateOwners`, props<{ owner: any }>()
)

export const setRelatedContracts = createAction(
    `${SOURCE} SetRelatedContracts`, props<{ relatedContracts: ContractRelatedDto[] }>()
)

export const setSelectedTab = createAction(
    `${SOURCE} SetSelectedTab`, props<{ selectedTab: number }>()
)

export const updateTenants = createAction(
    `${SOURCE} UpdateTenants`, props<{ tenant: any }>()
)

export const updateContractCpdsUseParcelRent = createAction(
    `${SOURCE} UpdateContractCpdsUseParcelRent`, props<{ useParcelRent: boolean }>()
)

export const updateContractOwnerParamsPayoutDate = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDate`, props<{ payoutDate: string; displayedOwnerParam: number }>()
)
export const updateContractOwnerParamsPayoutDatesPayoutDate = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDatesPayoutDate`, props<{ contractPayoutDate: string }>()
)
export const updateContractOwnerParamsPayoutDatesPayoutDateByKey = createAction(
    `${SOURCE} UpdateContractOwnerParamsPayoutDatesPayoutDateByKey`, props<{ contractPayoutDate: string; key: number }>()
)

export const updateContractOwnerParamsPriceAdd = createAction(
    `${SOURCE} UpdateContractOwnerParamsPriceAdd`, props<{ newValue: number }>()
)
export const updateContractOwnerParamsPriceAddByKey = createAction(
    `${SOURCE} UpdateContractOwnerParamsPriceAddByKey`, props<{ newValue: number; key: number }>()
)

export const updateContractOwnerParamsTaxOwnerAdd = createAction(
    `${SOURCE} UpdateContractOwnerParamsTaxOwnerAdd`, props<{ newValue: number; paramKey: number }>()
)
export const updateContractOwnerParamsTaxOwnerAddAll = createAction(
    `${SOURCE} UpdateContractOwnerParamsTaxOwnerAddAll`, props<{ newValue: number }>()
)

export const setZpvypos = createAction(
    `${SOURCE} StZpvypos`, props<{ zpvypos: Zpvypo[] }>()
)

export const updateContractOwnerSignatory = createAction(
    `${SOURCE} UpdateContractOwnerSignatory`, props<{ representativeId: number; subjectId: number }>()
)

export const updateContractTenantSignatory = createAction(
    `${SOURCE} UpdateContractTenantSignatory`, props<{ representativeId: number; subjectId: number }>()
)

export const beforeSetOwners = createAction(
    `${SOURCE} BeforeSetOwners`, props<{ owners: any[] }>()
)
export const setOwners = createAction(
    `${SOURCE} SetOwners`, props<{ owners: any[] }>()
)
export const onSetOwners = createAction(
    `${SOURCE} OnSetOwners`, props<{ owners: any[]; isContractEdit?: boolean }>()
)

export const setOwnersSignDate = createAction(
    `${SOURCE} SetOwnersSignDate`, props<{ signDateList: any[] }>()
)

export const setTenantsSignDate = createAction(
    `${SOURCE} setTenantsSignDate`, props<{ signDateList: any[] }>()
)

export const setContractSignatories = createAction(
    `${SOURCE} setContractSignatories`, props<{ origin: RepresentativeOriginEnum }>()
)

export const beforeSetTenants = createAction(
    `${SOURCE} BeforeSetTenants`, props<{ tenants: any[]; isContractEdit?: boolean }>()
)
export const setTenants = createAction(
    `${SOURCE} SetTenants`, props<{ tenants: any[] }>()
)
export const onSetTenants = createAction(
    `${SOURCE}OnSetTenants`, props<{ tenants: any[]; isContractEdit?: boolean }>()
)

export const setContractTenantsIds = createAction(
    `${SOURCE} SetContractTenantsIds`, props<{ tenantIds: number[] }>()
)

export const replaceOwner = createAction(
    `${SOURCE} replaceOwner`, props<{ subject: SubjectContactResponseDto | Subject }>()
)

export const updateSubjectsSignDate = createAction(
    `${SOURCE} UpdateSubjectsSignDate`, props<{ signDateList: any[] }>()
)

export const setContractPriceAndTax = createAction(
    `${SOURCE} SetContractPriceAndTax`, props<{ priceContract: number; priceContractValorized: number; taxOwner: number; taxTenant: number }>()
)

export const noAction = createAction(
    `${SOURCE} NoAction`,
)

export const computeContractExpirationDate = createAction(
    `${SOURCE} ComputeContractExpirationDate`
)
export const computeContractFirstPossibleTerminationDate = createAction(
    `${SOURCE} ComputeContractFirstPossibleTerminationDate`
)

export const setRunningTask = createAction(
    `${SOURCE} SetRunningTask`, props<{ recomputePriceAndTaxNow: boolean; recomputePriceAndTaxPostponed: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxNow = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxNow`, props<{ recomputePriceAndTaxNow: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxPostponed = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxPostponed`, props<{ recomputePriceAndTaxPostponed: boolean }>()
)

export const prepareSetEditedCpd = createAction(
    `${SOURCE} PrepareSetEditedCpd`, props<{ editedCPD: any }>()
)

export const handleComputePriceAndTax = createAction(
    `${SOURCE} HandleComputePriceAndTax`, props<{ isPostponed: boolean; task: ContractTaskEnum }>()
)

export const setParcelsOrder = createAction(`${SOURCE} setParcelsOrder`,
    props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)

export const setContractParamTemplate = createAction(
    `${SOURCE} SetContractParamTemplate`, props<{ template: any }>()
)

export const setContractReusedPreviousExpiration = createAction(
    `${SOURCE} setContractReusedPreviousExpiration`, props<{ value: boolean }>()
)